module.exports = __webpack_public_path__ + "media/images/top/mainimage01-1aa2651953321ba4ec26eb8ba0efe9be.jpg";